import { z } from "zod";
import { myPlanSharePath, planShareId } from "./plan-share";
/**
 * The public gallery of shared plans (`D274`): a share its owner offers
 * under a title, published only after the owner of the app approves it, and
 * opened by anyone signed in through the same preview and review as a code
 * (`D273`).
 *
 * - `GET /me/plan-gallery` — the published entries, newest first.
 * - `POST /me/plan/shares/:shareId/gallery` — offer one's own live share;
 *   idempotent, answers the entry's state.
 * - `POST /me/plan-gallery/:shareId/report` — one report per account; three
 *   send the entry back to review.
 */
export const PLAN_GALLERY_ROUTES = {
    gallery: "/me/plan-gallery",
    offer: "/me/plan/shares/:shareId/gallery",
    report: "/me/plan-gallery/:shareId/report",
};
export function offerToGalleryPath(shareId) {
    return `${myPlanSharePath(shareId)}/gallery`;
}
export function reportGalleryPath(shareId) {
    return `${PLAN_GALLERY_ROUTES.gallery}/${encodeURIComponent(shareId)}/report`;
}
export const PLAN_GALLERY_TITLE_MIN = 3;
export const PLAN_GALLERY_TITLE_MAX = 60;
/** `POST /me/plan/shares/:shareId/gallery`. Strict (`D172`). */
export const offerToGalleryInput = z.strictObject({
    title: z
        .string()
        .trim()
        .min(PLAN_GALLERY_TITLE_MIN)
        .max(PLAN_GALLERY_TITLE_MAX),
});
export const galleryOfferOutput = z.object({
    shareId: planShareId,
    status: z.enum(["pending", "approved", "rejected"]),
});
const galleryEntry = z.object({
    dayCount: z.int().nonnegative(),
    lineCount: z.int().nonnegative(),
    shareId: planShareId,
    title: z.string(),
});
export const galleryOutput = z.object({ entries: z.array(galleryEntry) });
//# sourceMappingURL=gallery.js.map